var React = require('react');

function TdcLogoOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 47.997c-13.233 0-24-10.766-24-24v-.107a23.879 23.879 0 011.817-9.067 3.457 3.457 0 013.197-2.145h6.315a1.35 1.35 0 001.349-1.35V5.015a3.456 3.456 0 012.145-3.196C17.655.646 20.274.118 23.86 0h.137C37.235 0 48 10.765 48 24S37.235 47.997 24 47.997zM2.105 23.898v.1c0 12.072 9.821 21.894 21.895 21.894s21.895-9.822 21.895-21.895c0-12.074-9.821-21.895-21.895-21.895h-.086c-3.308.11-5.709.59-8.285 1.658a1.355 1.355 0 00-.847 1.251v6.315a3.459 3.459 0 01-3.453 3.453H5.014a1.358 1.358 0 00-1.253.847 21.77 21.77 0 00-1.656 8.272z"}));
}

TdcLogoOutline.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = TdcLogoOutline;

TdcLogoOutline.default = TdcLogoOutline;
